import { render, staticRenderFns } from "./modal-offers.vue?vue&type=template&id=6dc5409a&"
import script from "./modal-offers.vue?vue&type=script&lang=js&"
export * from "./modal-offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports